import { resolveSelfDisplayName } from "./userIdentity";

export const normalizeId = (value) => {
    if (value === undefined || value === null) {
        return null;
    }
    const normalized = String(value).trim();
    return normalized || null;
};

export const normalizeParticipantIds = (participantIds) => {
    if (!Array.isArray(participantIds)) {
        return [];
    }
    const uniqueIds = new Set();
    participantIds.forEach((participantId) => {
        const normalized = normalizeId(participantId);
        if (normalized) {
            uniqueIds.add(normalized);
        }
    });
    return Array.from(uniqueIds);
};

export const resolveDirectChatIdentity = ({ participantIds, currentUserId }) => {
    const normalizedParticipantIds = normalizeParticipantIds(participantIds);
    const normalizedCurrentUserId = normalizeId(currentUserId);
    const otherParticipantId = normalizedParticipantIds.find(
        (participantId) => !normalizedCurrentUserId || participantId !== normalizedCurrentUserId
    ) || null;
    const fallbackSelfId = normalizedCurrentUserId
        && normalizedParticipantIds.includes(normalizedCurrentUserId)
        ? normalizedCurrentUserId
        : null;
    const userId = otherParticipantId || fallbackSelfId;
    const isPersonal = Boolean(normalizedCurrentUserId && userId && userId === normalizedCurrentUserId);
    return {
        participantIds: normalizedParticipantIds,
        userId,
        isPersonal,
    };
};

export const buildSelfDisplayName = (user, fallback = "You") => {
    return resolveSelfDisplayName(user, fallback);
};
